import type { Disposable } from '../common/disposable';

/**
 * Creates a disposable event listener that can be used to add and remove event listeners on an EventTarget.
 * @param target The target on which to add the event listener.
 * @param type The type of the event to listen for.
 * @param listener The event listener function or object.
 * @param options Optional. An object that specifies characteristics about the event listener.
 * @returns A Disposable object that can be used to remove the event listener.
 */
export function createDisposableListener(
    target: EventTarget,
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
): Disposable {
    target.addEventListener(type, listener, options);
    return {
        dispose() {
            target.removeEventListener(type, listener, options);
        },
    };
}
